const TextFormattingNodeSpec = {
  content: 'inline*',
  group: 'block',
  draggable: false,
  attrs: {
    align: { default: 'left' },
  },
};

const alignPattern = /(left|right|center|justify)/;

function getTextFormattingNodeAttrs(dom) {
  const {
    textAlign,
  } = dom.style;

  const attrs = {};

  const align = dom.getAttribute('align') || textAlign || '';

  if (align && alignPattern.test(align)) {
    attrs.align = align;
  }

  return attrs;
}

function getTextFormattingDOM(node) {
  const {
    align,
  } = node.attrs;

  const attrs = {};
  let style = '';

  if (align && align !== 'left') {
    style += `text-align: ${align};`;
  }

  if (style) {
    attrs.style = style;
  }

  return ['p', attrs, 0];
}

export {
  TextFormattingNodeSpec,
  getTextFormattingNodeAttrs,
  getTextFormattingDOM,
};
